import { Link } from "react-router-dom";
import styled from "styled-components";

export const FooterContainer = styled.footer`
    background-color: #1B335A;    
`;

export const FooterWrap = styled.div`
    padding: 12px 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 1100px;
    margin: 0 auto;
`;

export const FooterLinksContainer = styled.div`
    display: flex;
    justify-content: center;
`;

export const FooterLinksWrapper = styled.div`
     display: flex;

     @media screen and (max-width: 820px) {
        flex-direction: column;
    }

`;

export const FooterLinkItems = styled.div`
    align-items: center;
    text-align: center;
    width: 400px;
    box-sizing: border-box;
    color: antiquewhite;
    grid-template-columns: 1fr 1fr; 

    @media screen and (max-width: 420px) {
        margin: 0;
        padding: 10px;
        width: 100%;     
        grid-template-columns: 1fr;    
    }
`;

export const FooterLinkTitle = styled.div`
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 16px;
    color: #2BBAE0;
`;

export const FooterLink = styled(Link)`
    color: #fff;
    text-decoration: none;
    margin-bottom: 0.5rem;
    font-size: 16px;
    margin: 12px;
    &:hover{
        color: #F48E18;
        transition: 0.3s ease-in-out;
    }
`;

export const SocialMedia = styled.section`
    max-width: 800px;
    width: 100%;    
`;

export const SocialMediaWrap = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1000px;
    margin: 40px auto 0 auto;

    @media screen and (max-width: 820px) {
        flex-direction: column;        
    }
`;

export const SocialLogo = styled(Link)`
    color: #fff;
    justify-self: start;
    cursor: pointer;
    text-decoration: none;
    font-size: 1.5rem;
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    font-weight: bold;
`;

export const WebsiteRights = styled.small`
    color: #fff;
    margin-bottom: 16px;
`;

export const SocialIcons = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 120px;
    
`;

export const SocialIconLink = styled.a`
    color: antiquewhite;
    text-decoration: none;
    margin-bottom: 0.5rem;
    font-size: 24px;
    margin: 12px;

    &:hover{
        color: #F48E18;
        transition: 0.3s ease-in-out;
    }

    @media screen and (max-width: 520px) {
        font-size: 14px;      
    }
`;

export const ColorLine = styled.div`
    width: 100%;
    margin-top: 0px;
    display: flex;
    justify-content: baseline;

`;